var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"button",class:_vm.isDark? 'text-white' : 'text-muted',on:{"click":_vm.refreshArticles}},[_c('i',{staticClass:"fa fa-sync",class:_vm.isTransitioning? 'rotating' : 'clickable'})])
}
var staticRenderFns = []

export { render, staticRenderFns }